import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import { shouldForwardProp } from "../../../common/Common.style";
import theme from "../../../theme";

export const FormContentWrapper = styled(Box)`
  padding-left: 5px;
  padding-right: 10px;
  .array-layout {
    display: flex;
    justify-content: space-between;
  }
`;

export const FormDetailWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5px;
  gap: 10px;
`;

export const NotesContainerStyle = styled(Box)`
  background-color: ${({ theme }) => (theme as Theme).palette.background.paper};
  padding: 4px 8px;
  margin-top: 10px;
  border-radius: 4px;
`;

export const FormDetailTitle = styled(Typography)`
  font-weight: 500;
  margin-bottom: 3px;
  padding-top: 8px;
  font-size: 15px;
`;

export const FormDetailItem = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  text-align: left;
`;

type FormDetailValueProps = {
  color?: string;
};

export const FormDetailValue = styled(Typography, {
  shouldForwardProp: prop =>
    shouldForwardProp<FormDetailValueProps>(["color"], prop),
})<FormDetailValueProps>(({ color }) => ({
  fontWeight: "500",
  fontSize: "14px",
  textAlign: "right",
  color: color || theme.palette.text.primary,
}));

export const NotesTitle = styled(Typography)`
  font-size: 14px;
`;

export const NotesContent = styled(Typography)`
  font-size: 14px;
  font-style: italic;
`;
